export default "/tax-rebate/@rebateId"